module.exports = __webpack_public_path__ + "img/dashboard.99ead3b4.svg";